import {
  ContractsEmployeesContractVersionFragment,
  ContractsEmployeesJobCatalogContextlessPoliciesFragment,
  ContractsEmployeesReferenceContractFragment,
  JobCatalogTreeFragment,
} from 'generated/resources/graphql'

import RequestPromoteFlowContent from './_RequestPromoteFlowContent'

interface Props {
  contractVersion: ContractsEmployeesReferenceContractFragment
  jobCatalogTrees?: JobCatalogTreeFragment[]
  jobCatalogTreeFeatureEnabled?: boolean
  jobCatalogContextlessPolicies: ContractsEmployeesJobCatalogContextlessPoliciesFragment | undefined
  hasPayrollBundle: boolean
  contractVersions: ContractsEmployeesContractVersionFragment[]
}

const RequestPromoteFlow = ({
  contractVersion,
  jobCatalogTrees,
  jobCatalogTreeFeatureEnabled,
  jobCatalogContextlessPolicies,
  hasPayrollBundle,
  contractVersions,
}: Props) => {
  return (
    <RequestPromoteFlowContent
      jobCatalogTrees={jobCatalogTrees}
      jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
      contractVersion={contractVersion}
      contractVersions={contractVersions}
      jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
      hasPayrollBundle={hasPayrollBundle}
    />
  )
}

export default RequestPromoteFlow
